import { ImageSize } from "@toolkit/Framework/Types/Theme";

export default (width: number, height = width): ImageSize => ({
    width,
    height,
    ratio: height / width,
});
